import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, Observable } from 'rxjs';
import { LanguageService } from '../../../../../../core/services/language.service';
import { CardOptionType } from '../../../../../../osp-ui/components/form/card-option-list/contracts/card-option-type.contract';
import { SelectOption } from '../../../../../../osp-ui/components/form/select/select.component';
import { OptionConverterService } from '../../../../../../shared/services/option-converter.service';
import { EquipmentsApiService } from '../../../../../resources/equipment/services/equipments-api.service';
import { StockType } from '../../../enums/stock-type.enum';
import { StockTypeResolverService } from '../../../services/stock-type-resolver.service';

type StockTypeWithoutMain = Exclude<StockType, StockType.MAIN>;

@Injectable()
export class StockAddEditDialogFormOptionsService {
  private readonly optionConverterService = inject(OptionConverterService);
  private readonly equipmentService = inject(EquipmentsApiService);
  private readonly stockTypeResolverService = inject(StockTypeResolverService);
  private readonly languageService = inject(LanguageService);

  private readonly ORGANISATIONS_PAGE_SIZE = 5000; // We fetch a very high number because there is not pagination strategy for dropdown components so far

  readonly $organisations = toSignal(this.getOrganisationOptions(), { initialValue: [] });
  readonly stockTypes: CardOptionType[] = Object.values(StockType)
    .filter((type): type is StockTypeWithoutMain => type !== StockType.MAIN)
    .map((type) => ({
      type,
      label: this.stockTypeResolverService.resolveName(type),
      description: this.languageService.getInstant(
        `modules.locations.stock.create.typeSelection.description.${type.toLowerCase()}`,
      ),
      icon: this.stockTypeResolverService.resolveIcon(type),
    }));

  private getOrganisationOptions(): Observable<SelectOption[]> {
    return this.equipmentService
      .getOrganisations(0, this.ORGANISATIONS_PAGE_SIZE)
      .pipe(map((res) => this.optionConverterService.convertOrganisationInfo(res.content)));
  }
}
